import { collection, onSnapshot } from "firebase/firestore";
import { db } from "@/lib/firebase";
import { createSharedSubscription } from "@/lib/firestore/createSharedSubscription";
import { toMillis } from "@/lib/timestamps";
import type { Task } from "@amazing-wedding/shared-types";

export const tasksSubscription = createSharedSubscription<Task[]>({
  getDefault: () => [],
  attach: (weddingId, setSnapshot) => {
    setSnapshot({ data: [], loading: true });
    return onSnapshot(
      collection(db, "weddings", weddingId, "tasks"),
      (snap) => {
        const rows: Task[] = [];
        snap.forEach((d) => {
          const data = d.data() as Omit<Task, "id">;
          rows.push({ id: d.id, ...data });
        });
        rows.sort((a, b) => toMillis(a.createdAt) - toMillis(b.createdAt));
        setSnapshot({ data: rows, loading: false });
      },
      () => setSnapshot({ data: [], loading: false }),
    );
  },
});
